module.exports = __webpack_public_path__ + "img/logo-white.cf060fc5.svg";